module.exports = __webpack_public_path__ + "media/1.adf2d753.mp3";